import { render, staticRenderFns } from "./SupplierAdmin.vue?vue&type=template&id=08876e2a&"
import script from "./SupplierAdmin.vue?vue&type=script&lang=js&"
export * from "./SupplierAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports